export default __webpack_public_path__ + "static/media/test-image.e7f94dbf.jpg";